import { z } from "zod";

import { dashboardMetricsMatchers } from "./_dashboard-metrics-matchers";

export const dashboardMetricLabelNamesVariableSchema = z.object({
	matchers: dashboardMetricsMatchers,
});

export type DashboardMetricLabelNamesVariable = z.infer<typeof dashboardMetricLabelNamesVariableSchema>;
